export default "__VITE_ASSET__0e913b92__"